/**
 * Mounted once per open mission (MissionShell): loads my spoken-update preferences and speaks the
 * callouts the server sends me (aircraft updates, producer calls, crew replies) — unless the Airview Studio
 * app speaks them itself (lib/speech).
 */
import { useEffect } from 'react';
import { onCalloutMessage } from '../../lib/ws';
import { speakCallout, syncNativeVoice } from '../../lib/speech';
import { useCallouts } from '../../state/callouts';
import { useMission } from '../../state/mission';

export function useSpokenUpdates(): void {
  const missionId = useMission((s) => s.bundle?.mission.id ?? null);
  const myUserId = useMission((s) => s.bundle?.me.userId ?? null);
  const load = useCallouts((s) => s.load);

  useEffect(() => {
    void load();
    syncNativeVoice(); // the Airview Studio app speaks with the voice picked on this device
  }, [load]);

  useEffect(() => {
    if (!missionId) return;
    return onCalloutMessage((c) => {
      if (c.missionId !== missionId || (myUserId && c.userId !== myUserId)) return;
      const receivedAt = Date.now();
      if (!useCallouts.getState().receive(c, receivedAt)) return;
      if (useCallouts.getState().prefs?.enabled) speakCallout(c.text, receivedAt);
    });
  }, [missionId, myUserId]);
}
